export default "__VITE_ASSET__uRZR4D0r__";